import type { LocaleCode } from "../types/locale-code";

import { getLocaleMetadata } from "../registry/locale-registry";

function getPostalCodeRequiredErrorMessage(localeCode: LocaleCode): string {
  return getLocaleMetadata(localeCode).country.postalCodeRequiredErrorMessage;
}

export { getPostalCodeRequiredErrorMessage };
